<template>
  <LoaderItem v-if="this.loading"></LoaderItem>

  <div class="container-fluid alt-container" >

    <div class="row header-panel nav-alt">
      <div class="col-3 left_side">
        <div class="login_logo_wrapper">
          <span>v2.0</span>
        </div>
      </div>
      <div class="col-9 right_side">
        <NavItem/>
      </div>
    </div>

    <div v-if="this.temperatures" class="row content-panel d-flex justify-content-between">
      <div class="d-none d-md-block col-3 content-side">
        <LeftSideReportsItem/>
      </div>

      <div class="col-9 content">
        <div class="d-flex justify-content-start  content-header no-bottom-border bread-area">
          <img src="/svgs/arrow-circle-left.svg"  class="back-button" @click.prevent="goBack" alt="" width="30" height="30">
          <BreadCrumb :crumbs="getBreadCrumbs"/>
        </div>

        <div class="content-body" >

          <div class="col-md-2 col-sm-4 form-group mb-3 range-filter">
            <DateRangePicker :changed-date-range="this.onChangeDateRange" date-range-value="dateRangeValue" element-id="sensorReportingRange"/>
          </div>

          <Transition name="fade" mode="out-in">
            <apexchart ref="chartRef" height="100%" width="99%" type="line" :options="this.chartOptions" :series="this.series"></apexchart>
          </Transition>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import LeftSideReportsItem from "@/components/partials/LeftSideReportsItem";
import DateRangePicker from "@/components/partials/reusable/DateRangePicker";
import NavItem from "@/components/partials/NavItem";
import moment from "moment";
import BreadCrumb from "@/components/partials/BreadCrumb";
import LoaderItem from "@/components/partials/LoaderItem";
import {ref} from "vue";
import VueApexCharts from "vue3-apexcharts";


export default {
  name: "SensorReportingItem",
  components: {
    BreadCrumb,
    NavItem,
    LeftSideReportsItem,
    LoaderItem,
    apexchart: VueApexCharts,
    DateRangePicker,
  },
  computed:{
    temperatures(){
      return this.$store.state.warehouse.temperatureData.data
    },
    warehouses(){
      return this.$store.state.warehouse.list.data
    },
     sensor(){
       return this.$store.state.warehouse.selectedSensor
     },
    getBreadCrumbs(){
        if (this.temperatures){
          let warehouse = this.temperatures.sensor.room_to_sensor.room.warehouse
          let warehouseRooms = this.warehouses.list.filter(item => item.id === warehouse.id)[0].warehouse_rooms

          return [
            {"name": this.temperatures.sensor.room_to_sensor.room.warehouse.name, route:{url:'dashboard', params: { roomId: warehouseRooms.map(it => it.id)}  } },
            {"name": this.temperatures.sensor.room_to_sensor.room.name, route:{url:'dashboard', params: { roomId: this.temperatures.sensor.room_to_sensor.room.id}  } },
            {"name":this.temperatures.sensor.name + ' - ' + this.temperatures.sensor.serialnumber, "active":true}
          ]
        }
        return []
    }
  },
  data(){
    const chartTimes = ref([])

    let chartOptions = {
      grid:{
        strokeDashArray: 12,
      },
      colors: ["#9D85FF", "#5AA8ED"],
      chart: {
        id: 'chart',
        type:'line',
        toolbar: {
          tools: {
            // zoomin: '<img src="/svgs/add2-before.svg" width="24" height="24">',
            // zoomout: '<img src="/svgs/remove.svg" width="24" height="24">',
            // pan: '<img src="/svgs/hand.svg"/>',
            // zoom: '<img src="/svgs/zoom.svg" width="24" height="24">',
            // reset: '<img src="/svgs/home-v2.svg" width="20" height="20">'
          }
        },
        events:{
          beforeZoom : (e, {xaxis}) => {
            let maindifference = (new Date(this.series[0].data[0].x)).valueOf() - new Date(this.series[0].data[this.series[0].data.length-1].x).valueOf();
            let zoomdifference =   xaxis.max - xaxis.min ;
            if( zoomdifference > maindifference )
              return  {
                // dont zoom out any further
                xaxis: {
                  min: this.series[0].data[0].date,
                  max: this.series[0].data[this.series[0].data.length-1].date
                }
              };
            else {
              return {
                // keep on zooming
                xaxis: {
                  min: xaxis.min,
                  max: xaxis.max
                }
              }
            }
          }
        }

      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
		tooltip: {
			x: {
				show: true,
				format: 'HH:mm',
			},
		},
      xaxis: {
        type: 'datetime',
        categories: chartTimes,
        labels: {
          datetimeUTC: false
        },
        tooltip: {
          enabled: false
        }
      },
      yaxis:[
        {
          title: {
            text: 'ტემპერატურა',
          },
        },
        {
        opposite: true,
        title: {
          text: 'ტენიანობა',
        },
      }],
    }

    return {
      dataCollection: null,
      selectedSensor: null,
      loading: true,
      chartOptions: chartOptions,
      chartTimes: chartTimes,
      series: ref([]),
      chartRef: ref(null),
    }
  },
  methods:{
    fetchSeries(){
		let chartTimes = []
		let chartTempos = []
		let chartHumidity = []

		this.temperatures.data.forEach(item => {
			const ts = moment(item.trunc_60_minute).valueOf();
			chartTimes.push(ts);
			chartTempos.push({
				y: item.tempo_average === null ? '0' : parseFloat(item.tempo_average),
				x: ts
			})
			chartHumidity.push({
				y: item.humidity_average === null ? '0' : parseFloat(item.humidity_average),
				x: ts
			})
		})

		this.series = [{
			name: 'ტემპერატურა',
			data: chartTempos,
		}]
		this.series.push({
			name: 'ტენიანობა',
			data: chartHumidity,
		})

      let sensorAlerts = this.temperatures.sensorAlerts.map(item => {
        return {
          y: parseFloat(item.value2),
          borderColor:  '#f47b7a',
          strokeDashArray: 0,
          label: {
            show: true,
            text: parseInt(item.value1) === 1 ? `ლიმიტი აწევისას ${item.value2} ℃`  : `ლიმიტი დაწევისას ${item.value2} ℃` ,
            style: {
              color: "#fff",
              background: '#f47b7a'
            }
          }
        }
      })
      this.chartOptions = { ...this.chartOptions,
        ...{
          annotations: {
            yaxis:sensorAlerts
          }
        }
      }

    },
    fillData(){
      if (this.temperatures ){
        console.log("fill data empty")
        return true
      }
      return false
    },
    goBack(){
      this.$router.push({name: 'dashboard', params: { roomId: this.temperatures.sensor.room_to_sensor.room.id } })
    },
    onChangeDateRange(ranges){
      this.loading = true
      this.$store.dispatch('warehouse/fetchSensorTemperatureData',{
        sensorId:this.sensor.id, ...ranges,
        range:null
      }).then( () => {
        this.fetchSeries()
        this.loading = false
      })
    }
  },
  created() {
    if (this.sensor !== null){
      this.$store.dispatch('warehouse/fetchSensorTemperatureData',this.sensor.id).then(
          () => {
            this.fetchSeries()
            this.loading = false
          }
      )
    }else{
      this.$router.push('/')
    }
  },
  unmounted() {
    this.$store.state.warehouse.temperatureData.data = null
  },
  setup() {
  }
}
</script>

<style>

.alt-container .col-3{
  width: 20%;
}
.alt-container .col-9{
  width: 79.5%;
}
.table-striped > tbody > tr:nth-child(odd) > td, .table-striped > tbody > tr:nth-child(odd) > th {
  /*background-color: var(--hover-item);*/
}

.back-button{
  cursor: pointer;
}

.apexcharts-yaxis-annotation-label{
  padding:10px;
  font-size: 14px;
}



#sensorReportingRange{
  width: 180px;
}

/*#apexchartschart{*/
/*  padding-top:10px;*/
/*}*/

.apexcharts-toolbar{
  top: -4% !important;
}
.content-header{
  margin-top:0;
}

.content-body{
  position: relative;
  height: 75vh;
  padding-top:10px;
}

.range-filter{
  position: absolute;
  top: -2%;
  left: 0;
}

@media only screen and (min-width: 1198px) and (max-width: 1679px) {
  .apexcharts-yaxis-annotation-label{
    font-size: 12px;
  }

  table thead tr td img{
    width: 20px;
  }
}

</style>